import { render, staticRenderFns } from "./approvalDetails.vue?vue&type=template&id=f696c7e2&scoped=true&"
import script from "./approvalDetails.vue?vue&type=script&lang=js&"
export * from "./approvalDetails.vue?vue&type=script&lang=js&"
import style0 from "./approvalDetails.vue?vue&type=style&index=0&id=f696c7e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f696c7e2",
  null
  
)

export default component.exports